// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

// slick
import $ from 'jquery';
import 'third/jquery.slick';

export default class ProductListSlider extends WebComponent {
  didMount() {
    const slider = $('.product-list-slider');
    setTimeout(() => {
      if (document.documentElement.getAttribute('dir') === 'rtl') {
        $(this.element).slick({
          rtl: true,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          prevArrow: '<span class="product-list-slider__arrow product-list-slider__arrow--prev"><svg class="svg-icon"><use xlink:href="#arrow-left"></use></svg></span>',
          nextArrow: '<span class="product-list-slider__arrow product-list-slider__arrow--next"><svg class="svg-icon"><use xlink:href="#arrow-right"></use></svg></span>',
          infinite: true,
          speed: 500,
          cssEase: 'ease-in-out',
          centerPadding: '10px',
          draggable: true,
          // rows: 0,
          variableWidth: false,
          responsive: [
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 4,
                dots: false,
              },
            },
          ],
        });
      }else {
        $(this.element).slick({
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          prevArrow: '<span class="product-list-slider__arrow product-list-slider__arrow--prev"><svg class="svg-icon"><use xlink:href="#arrow-left"></use></svg></span>',
          nextArrow: '<span class="product-list-slider__arrow product-list-slider__arrow--next"><svg class="svg-icon"><use xlink:href="#arrow-right"></use></svg></span>',
          infinite: true,
          speed: 500,
          cssEase: 'ease-in-out',
          centerPadding: '10px',
          draggable: true,
          // rows: 0,
          variableWidth: false,
          responsive: [
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 4,
                dots: false,
              },
            },
          ],
        });
      }}, 200);

    $(window).resize(() => {
      $(this.element).slick('resize');
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ProductListSlider.js